module.exports = __webpack_public_path__ + "static/media/sax.4647ed3a.m4a";